<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Lista de grupos</h6>
              <router-link
                :to="{ name: 'Group Create' }"
                class="btn btn-primary btn-sm"
                data-toggle="tooltip"
                data-original-title="Agregar grupo"
              >
                Agregar <i class="fa fa-plus ms-1"></i>
              </router-link>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar grupo..."
                  @input="fetchGroups"
                />
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Grupo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Integrantes
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="group in filteredGroups" :key="group.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ group.name }}</h6>
                          <p class="text-xs text-secondary mb-0">{{ group.description }}</p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ oficioNames(group) || 'Sin oficio' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <a class="badge badge-sm bg-gradient-primary cursor-pointer"
                        @click="openMembersModal(group)"
                        title="Ver integrantes"
                        data-toggle="tooltip" data-original-title="Ver integrantes">
                        {{ (group.users && group.users.length) || 0 }}
                        <i class="fa fa-eye ms-1"></i>
                      </a>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="group.status == 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ group.status == 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link :to="{ name: 'Group Create', params: { group: JSON.stringify(group) }, props: true }"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Editar grupo">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>
                      <a @click="deleteGroup(group.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar grupo">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="groups.length === 0">
                    <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Integrantes del grupo -->
    <div class="modal fade" id="ModalGroupMembers" tabindex="-1" aria-labelledby="ModalGroupMembersLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalGroupMembersLabel">
              Integrantes: {{ membersModalGroup?.name }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="text-secondary text-xs mb-2" v-if="membersModalGroup && oficioNames(membersModalGroup)">
              Oficios: <strong>{{ oficioNames(membersModalGroup) }}</strong>
            </p>
            <ul class="list-group" v-if="membersModalGroup?.users && membersModalGroup.users.length > 0">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                v-for="member in membersModalGroup.users" :key="member.id">
                <div>
                  <h6 class="mb-0 text-sm">{{ member.name }}</h6>
                  <small class="text-secondary">{{ member.email }}</small>
                </div>
                <span class="badge badge-sm bg-gradient-secondary">{{ member.document || 'Sin documento' }}</span>
              </li>
            </ul>
            <p v-else class="text-center text-secondary text-sm mb-0">El grupo no tiene integrantes</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';
export default {
  name: 'GroupList',
  data() {
    return {
      groups: [],
      searchQuery: '',
      membersModalGroup: null,
      membersModalInstance: null,
    };
  },
  computed: {
    filteredGroups() {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) return this.groups;
      return this.groups.filter(group =>
        group.name.toLowerCase().includes(query) ||
        this.oficioNames(group).toLowerCase().includes(query)
      );
    },
  },
  methods: {
    oficioNames(group) {
      const oficios = group.oficios?.length ? group.oficios : (group.oficio ? [group.oficio] : []);
      return oficios.map(o => o.name).join(', ');
    },
    async fetchGroups() {
      try {
        const response = await this.$store.dispatch('groups/fetchData');
        this.groups = response || [];
      } catch (error) {
        console.error("Error al cargar los grupos:", error);
      }
    },
    openMembersModal(group) {
      this.membersModalGroup = group;
      if (!this.membersModalInstance) {
        this.membersModalInstance = new Modal(document.getElementById('ModalGroupMembers'));
      }
      this.membersModalInstance.show();
    },
    async deleteGroup(groupId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("groups/delete", groupId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchGroups();
            await Swal.fire(
              'Eliminado!',
              'El grupo ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el grupo');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el grupo:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el grupo',
        });
      }
    }
  },
  mounted() {
    this.fetchGroups();
  },
};
</script>
